import { Pipe, PipeTransform } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

@Pipe({
    name: 'imageToBase64',
    standalone: false
})
export class ImageToBase64Pipe implements PipeTransform {

  constructor(private http: HttpClient) {}

  transform(url: string): Observable<string> {
    return this.http.get(url, { responseType: 'blob' }).pipe(
      switchMap(blob => {
        const reader = new FileReader();
        const base64Observable = new Observable<string>((observer) => {
          reader.onloadend = () => {
            observer.next(reader.result as string);
            observer.complete();
          };
          reader.onerror = (err) => {
            observer.error(err);
          };
        });
        reader.readAsDataURL(blob);
        return base64Observable;
      }),
      catchError(() => of('Error: could not load image'))
    );
  }
}
